import { SOCIAL_FIELDS } from '../../../lib/socialLinks'

/** Charity socials — website comes from IRS and is not editable here. */
export const CHARITY_SOCIAL_FIELDS = SOCIAL_FIELDS.filter(
  field => field.key !== 'website_link',
)

export const DONATION_LINK_FIELDS = [
  'external_donation_url',
  'amazon_wishlist_url',
]

export const SOCIAL_LINK_FIELDS = CHARITY_SOCIAL_FIELDS.map(field => field.key)
